import httpAdapter from 'axios/lib/adapters/http' // eslint-disable-line import/no-extraneous-dependencies

export default async function httpByMidwayAdapter(config) {
  const {
    method, url, headers, context, params, matchedPath,
  } = config

  if (method !== 'get') return httpAdapter(config)

  const { callHttp, kibanaLog } = context?.ssrUtils

  if (!callHttp) return httpAdapter(config)

  try {
    const result = await callHttp({
      url,
      service: 'prefetch',
      funcName: matchedPath,
      option: {
        method,
        data: params,
        headers,
        funcName: matchedPath,
      },
      extractData: false,
    })

    if (result) {
      const response = {
        ...result,
        config,
      }

      return response
    }

    throw new Error('The result returned from callHttp is not success')
  } catch (error) {
    kibanaLog({
      ctx: context,
      logArg: {
        message: `Http By Midway Adapter ERROR DEATIL : ${error}`,
        prdline: 'fedatalog',
        prefetchUrl: url,
        prefetchData: params,
        prefetchMatchedPath: matchedPath,
      },
    })
    return httpAdapter(config)
  }
}
